import React from 'react';
import { useIntl } from 'react-intl';

import globalCss from '../DesktopUniversalSearch/DesktopUniversalSearch.module.css';
import { SEARCH_TAB } from './DesktopUniversalSearch';
import classes from './LocationSearchInput.module.css';

interface ILocationSearchInputProps {
  getInputProps: () => Record<string, never>;
  className?: string;
  isTowables: boolean;
  selectedTab: SEARCH_TAB | null;
  isCategoryEnabled?: boolean;
  isStayFilterEnabled?: boolean;
}

const LocationSearchInput: React.FC<ILocationSearchInputProps> = ({
  getInputProps,
  className = '',
  isTowables,
  selectedTab,
  isCategoryEnabled,
  isStayFilterEnabled,
}) => {
  const intl = useIntl();

  const getLocationPlaceholder = () => {
    return intl.formatMessage({
      defaultMessage: 'Location',
      id: 'cGCkb9',
      description: 'Global Header > Placeholder text for header search field',
    });
  };

  const getNoValuePlaceholder = () => {
    return intl.formatMessage({
      defaultMessage: 'Where will your adventure start?',
      id: 'S/dTIs',
    });
  };

  const locationPlaceholder = getLocationPlaceholder();

  const homeLocationPlaceholder = intl.formatMessage({
    defaultMessage: 'Type to search',
    id: '0bIwFw',
    description: 'Global Header > Placeholder text for header search field',
  });

  const noValuePlaceholder = getNoValuePlaceholder();

  // For other tags
  const { 'aria-controls': ariaControls, value } = getInputProps();
  // For input
  const { onFocus, ...inputProps } = getInputProps() as { onFocus?: () => void };

  return (
    <div
      className={`${className} ${
        isTowables || selectedTab === SEARCH_TAB.LOCATION
          ? isStayFilterEnabled
            ? 'rounded-tr-2xl'
            : 'rounded-none'
          : 'lg:rounded-2xl'
      } ${isTowables ? classes.towableLocationTab : classes.locationTab} ${
        !isCategoryEnabled ? 'rounded-tl-2xl rounded-tr-2xl lg:!rounded-tr-none' : ''
      } ${isStayFilterEnabled ? 'rounded-t-2xl' : ''}`}>
      <div className={classes.homeInputContainer} data-focus={!!ariaControls}>
        <span className={globalCss.homeLabel}>{locationPlaceholder}</span>
        <input
          className={classes.homeInput}
          placeholder={homeLocationPlaceholder}
          onFocus={e => {
            onFocus?.();
            e.target.select();
          }}
          {...inputProps}
        />
        {!value && <span>{noValuePlaceholder}</span>}
      </div>
    </div>
  );
};

export default LocationSearchInput;
